import React from "react";
import { nmmsOptions } from "../../../../Options/genExamOptions";
import DeselectableRadioGroup from "../../../../../../blocks/FormItems/DeselectableRadioGroup";

const Pallor = ({ form }) => {
  return (
    <>
      <DeselectableRadioGroup
        label={"Pallor"}
        name={"pallor"}
        options={nmmsOptions}
        form={form}
      />
    </>
  );
};

export default Pallor;
